import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface TableButtonProps {
    tableNumber?: string;
    tableTime?: string;
    peopleCount?: number;
    showPeople?: boolean;
    showArrow?: boolean;
    className?: string;
    onClick?: () => void;
    backgroundColor?: string;
    color?: string;
}

const TableButton: React.FC<TableButtonProps> = ({
    tableNumber = "01",
    tableTime = "10.00 am",
    peopleCount = 4,
    showPeople = true,
    showArrow = true,
    className = "",
    onClick,
    backgroundColor = "#0A2398",
    color = "#0A2398",
}) => {
    return (
        <button
            className={`status_button ${className}`}
            onClick={onClick}
            style={{ backgroundColor }}
        >
            <div className={`table_card ${!showPeople ? 'align-top' : ''}`}>
                <div className='table_info' >
                    <div className='table_number_time'>
                        <p className='table_number' style={{color}}>{tableNumber}</p>
                        <p className='table_time'>{tableTime}</p>
                    </div>

                    {showPeople && (
                        <div className='table_people'>
                            <PersonIcon />
                            <p className='people_count'>{peopleCount} people</p>
                        </div>
                    )}
                </div>
            </div>

            {showArrow && (
                <div className='arrow'>
                    <ArrowForwardIcon />
                </div>
            )}
        </button>
    );
};

export default TableButton;
